// This component renders the stall details for the main event.
//  The details for the stalls are hardcoded for now.

import { useEvent } from "../../../context/EventContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Modal from "react-modal";
import { useState } from "react";
import { IoCloseSharp } from "react-icons/io5";
import Loader from "../../Loader/Loader";
import eventsAPI from "../../../api/eventsAPI";
import { useAuth } from "../../../context/AuthContext";

Modal.setAppElement("#root"); // Set the app root element for accessibility

//  In the future, this should be replaced with actual data from the database.
const Stall = () => {
  const { selectedEvent, loading, setLoading } = useEvent();
  const { user } = useAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStall, setSelectedStall] = useState(null);

  const stallDetailsArray =
    selectedEvent && selectedEvent[5] ? selectedEvent[5] : [];

  const stallBookingData =
    selectedEvent && selectedEvent[8] ? selectedEvent[8] : [];

  // Change to check if the selected stall is booked by the user
  const isStallBooked = selectedStall
    ? stallBookingData.some(
        (data) =>
          data?.user === user?.id && data?.stall_type_ID === selectedStall?._id
      )
    : false;

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      width: "400px",
      height: "371px",
      background: "#fff",
      color: "#000",
      border: "1px solid #ccc",
      borderRadius: "10px",
      padding: "20px",
      zIndex: "4",
      position: "fixed",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)", // This gives the screen a dark background
      zIndex: "3", // Ensures the overlay is behind the modal content
    },
  };

  const handleDetails = (stallDetails) => {
    setSelectedStall(stallDetails);
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleBooking = async (e) => {
    e.preventDefault();

    if (!selectedStall) {
      toast.error("No stall selected.");
      return;
    }

    try {
      const response = await eventsAPI.post("/data/stallBooking", {
        stall_type_ID: selectedStall?._id,
        user: user?.id,
        payment_status: true,
      });

      if (response.status === 200) {
        toast.success("Stall Booked Successfully");
        setIsModalOpen(false);
      }
    } catch (error) {
      setLoading(false);
      console.log("Error Booking Stall:", error);
    }
  };

  return (
    <>
      <div className="stall-data-section">
        <div className="stall-section-details">
          {stallDetailsArray.length === 0 && (
            <h1 style={{ paddingLeft: "300px" }}>No Stall Details found.</h1>
          )}
          {stallDetailsArray.map((stallDetails, index) => (
            <div key={index} className="stall-card">
              <p>Stall Name: {stallDetails?.stall_name}</p>
              <p>Stall Type: {stallDetails?.stall_type}</p>
              <button
                className="add-space"
                onClick={() => handleDetails(stallDetails)}
              >
                Show Details
              </button>
            </div>
          ))}
        </div>
        <div className="booked-stall-section">
          <h3>Booked Stalls Details</h3>
          {stallBookingData.length === 0 ? (
            <p>No Booked stalls Available.</p>
          ) : (
            <table>
              <thead>
                <tr>
                  <th>Stall Name</th>
                  <th>Stall Type</th>
                  <th>Booked By</th>
                  <th>Price</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {stallBookingData.map((booking, index) => {
                  const bookedStall = stallDetailsArray.find(
                    (stall) => stall._id === booking.stall_type_ID
                  );
                  return (
                    bookedStall && (
                      <tr key={index}>
                        <td>{bookedStall.stall_name}</td>
                        <td>{bookedStall.stall_type}</td>
                        <td>{booking.user}</td>
                        <td>{bookedStall.stall_price}₹</td>
                        <td>
                          {booking.payment_status === true
                            ? "Paid"
                            : "Not Paid"}
                        </td>
                      </tr>
                    )
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        overlayClassName="overlay"
        style={customStyles}
        contentLabel="Book Stall"
      >
        <div className="modal2">
          <div className="heading">
            <h2>Stall Details</h2>
            <IoCloseSharp
              onClick={() => handleClose()}
              className="close-icon"
            />
          </div>
          <div className="modal-details">
            <p>Stall Name: {selectedStall?.stall_name}</p>
            <p>Stall Type: {selectedStall?.stall_type}</p>
            <p>Stall Size: {selectedStall?.stall_size}</p>
            <p>Stall Price: {selectedStall?.stall_price}₹</p>
            <p>Number of Stalls: {selectedStall?.number_of_stalls}</p>
          </div>
          <div>
            {isStallBooked ? (
              <p style={{ color: "red", fontWeight: 550 }}>
                Stall Already Booked
              </p>
            ) : (
              <button
                type="button"
                onClick={(e) => handleBooking(e)}
                className="add-space"
              >
                {loading ? <Loader /> : "Book"}
              </button>
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Stall;
